import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Discover = () => {
    const discoverData = [
        {
            value: "150+",
            label: "Shopify Stores Built"
        },
        {
            value: "10+",
            label: "Years of Experience"
        },
        {
            value: "98%",
            label: "Client Satisfaction"
        },
        {
            value: "24/7",
            label: "Support Available"
        }
    ];
    return (
        <div className='bw_shopify_discover_section'>
            <Container className='bw_custome_footer_container'>
                <Row className='d-flex align-items-center'>
                    <Col sm={12} md={4} lg={4}>
                        <div className='bw_shopify_discover_section_left'>
                            <p>Discover why millions of
                                entrepreneurs chose Shopify
                                to build their business</p>
                        </div>
                    </Col>
                    <Col sm={12} md={8} lg={8}>
                        <div className='bw_shopify_discover_section_right'>
                            <ul>
                                {discoverData.map((val, index) =>
                                    <li>
                                        <div>
                                            <h6> {val.value}</h6>
                                            <p>{val.label}</p>
                                        </div>  
                                    </li>
                                )}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Discover